/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import AppFormActions from "./AppFormActions";
import BaseCom from "./BaseCom";
import Card from "./Card";
import { NavMenuGlobal } from "./NavMenu";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import L from "./Lang";
import Icon from "./Icon";
import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";

class CustomerProfile extends BaseCom {

    componentDidMount() {
        NavMenuGlobal.setPath('Customer;Profile');
        this.fillItem('/api/customer/item?id=' + this.props.params.id, 'info');
    }

    gps = async (shipID) => {
        try {
            let j = await qreq.getAsync('/api/customer/loc?custID=' + this.state.info.id + '&shipID=' + shipID);
            if (j.item) {
                if (Globals.iOS())
                    window.open('https://maps.apple.com/?q=' + j.item.lat + ',' + j.item.lng);
                else
                    window.open('https://www.google.com/maps/search/' + j.item.lat + ',' + j.item.lng);
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        if (!this.state.info)
            return;
        return (
            <div className="container-fluid">
                <AppFormActions showBackButton />
                <h1>{this.state.info.cust_name}</h1>
                <Card title="Customer Address">
                    <div>{this.state.info.address1}</div>
                    <div>{this.state.info.address2}</div>
                    <div>{this.state.info.address3}</div>
                    <div>{this.state.info.city}, {this.state.info.state}</div>
                    <div>{this.state.info.country}</div>
                    <div>{this.state.info.zipCode}</div>
                </Card>
                {this.state.info.shippings.map((i, idx) => <Card key={idx} title={'Shipping #' + i.ship_num}
                    headerButtons={<button className="btn btn-primary" onClick={() => this.gps(i.ship_num)}><Icon icon="faMapMarker" /></button>}>
                    <div>{i.address1}</div>
                    <div>{i.address2}</div>
                    <div>{i.address3}</div>
                    <div>{i.city}, {i.state}</div>
                    <div>{i.country}</div>
                    <div>{i.zipCode}</div>
                </Card>)}

                <Card>
                    <div className="d-grid gap-1">
                        <Link to={'/console/statement/' + this.state.info.id} className="btn btn-primary btn-lg">
                            <Icon icon="faFileInvoice" /> <L>Statement</L>
                        </Link>
                        <Link to="history" className="btn btn-primary btn-lg">
                            <Icon icon="faFileInvoice" /> <L>Order History</L>
                        </Link>
                    </div>
                </Card>
            </div>
        );
    }
}

export default withParamsAndNavigate(CustomerProfile);